/*
 * HomeConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

export const CHANGE_USERNAME = 'boilerplate/Home/CHANGE_USERNAME';
export const ON_CALL_UPLOAD = 'boilerplate/Landing/ON_CALL_UPLOAD';
export const PASS_INV_VAL = 'boilderplate/FailedInvoice/PASS_INV_VAL'
export const RESET_FETCH_PASS = 'boilerplate/ProcessedInvoice/RESET_FETCH_FAILED'
export const ON_NOTIFY = 'boilerplate/ProcessedInvoice/ON_NOTIFY'
export const LOADER_STATUS = 'boilderplate/ProcessedInvoice/LOADER_STATUS'
export const TOTAL_RECORD = 'boilerplate/ProcessedInvoice/TOTAL_RECORD'
export const GET_ITEM = 'boilderplate/ProcessedInvoice/GET_ITEM'
export const TOTAL_ITEM_RECORDS = 'boilderplate/ProcessedInvoice/TOTAL_ITEM_RECORDS'
export const TXN_RECORD = 'boilerplate/ProcessedInvoice/TXN_RECORD'
export const DISABLE_EDIT = 'boilderplate/ProcessedInvoice/DISABLE_EDIT'
export const SET_PASS_PAGE = 'boilerplate/ProcessedInvoice/SET_PASS_PAGE'
export const PROFILE_INFO = 'boilderplate/ProcessedInvoice/PROFILE_INFO';
export const SET_PDF_MODAL = 'boilerplate/ProcessedInvoice/SET_PDF_MODAL'